module.exports = (__webpack_require__(1))(2330);